import PropTypes from 'prop-types';

function shouldDisplayPrice(plot, displaySettings) {
  const baseConditions =
    plot.price &&
    plot.price !== '' &&
    displaySettings.price === '1' &&
    plot.status !== 'verkocht' &&
    plot.status !== 'voorbereiden-start-verkoop';

  return (
    (baseConditions && plot.status !== 'in-voorbereiding') ||
    (baseConditions &&
      plot.status === 'in-voorbereiding' &&
      plot.is_indicative_price === true)
  );
}
function shouldDisplayParking(plot) {
  return (
    plot.parking_count && plot.parking_description && plot.parking_count > 0
  );
}

function buildRegistrationButtonUrl(
  salesforceProjectUuid,
  registrationPageUrl,
  plotUuid
) {
  return `${registrationPageUrl}?project=${salesforceProjectUuid}&house=${plotUuid}`;
}

function toAbsoluteUrl(url) {
  if (typeof window === 'undefined' || !url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const origin = window.location.origin;
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${origin}${path}`;
}

function isInIframe() {
  if (typeof window === 'undefined') return false;
  return window.self !== window.top;
}

function notifyParentRegistrationClick(registrationUrl, plotUuid) {
  try {
    const absoluteUrl = toAbsoluteUrl(registrationUrl);
    window.parent.postMessage(
      {
        type: 'HEIJMANS_REGISTRATION_CLICK',
        source: 'heijmans-woningzoeker',
        registrationUrl: absoluteUrl,
        plotUuid: plotUuid,
      },
      '*'
    );
  } catch {
    // postMessage kan falen bij cross-origin
  }
}

/**
 * Checks if the registration button should be shown for a given plot.
 * @link https://project.rox.nl/app/tasks/25096936?c=6381013
 * @param {object} plot - The plot object
 * @returns {boolean} - Whether the registration button should be displayed
 */
function shouldShowRegistrationButton(plot) {
  switch (plot.status) {
    case 'te-koop':
    case 'in-optie':
      return plot.registration_page && plot.registration_page !== '';
    default:
      return false;
  }
}

/**
 * Checks if the downloads button should be shown for a given plot.
 * @link https://project.rox.nl/app/tasks/25096936?c=6381013
 * @param {object} plot - The plot object
 * @returns {boolean} - Whether the downloads button should be displayed
 */
function shouldShowDownloadsButton(plot) {
  switch (plot.status) {
    case 'te-koop':
    case 'in-optie':
      return plot.downloads_page && plot.downloads_page !== '';
    default:
      return false;
  }
}

/**
 * Checks if the favorite button should be shown for a given plot.
 * @link https://project.rox.nl/app/tasks/25096936?c=6381013
 * @param {object} plot - The plot object
 * @returns {boolean} - Whether the favorite button should be displayed
 */
function shouldShowFavoriteButton(plot) {
  switch (plot.status) {
    case 'in-voorbereiding':
    case 'te-koop':
    case 'in-optie':
      return true;
    default:
      return false;
  }
}

/**
 * Checks if the detail button should be shown for a given plot.
 * @link https://project.rox.nl/app/tasks/25096936?c=6381013
 * @param {object} plot - The plot object
 * @returns {boolean} - Whether the detail button should be displayed
 */
function shouldShowDetailButton(plot) {
  return plot.detail_page && plot.detail_page !== '';
}

buildRegistrationButtonUrl.propTypes = {
  salesforceProjectUuid: PropTypes.string.isRequired,
  registrationPageUrl: PropTypes.string.isRequired,
  plotUuid: PropTypes.string.isRequired,
};

shouldShowRegistrationButton.propTypes = {
  plot: PropTypes.object.isRequired,
};

shouldShowFavoriteButton.propTypes = {
  plot: PropTypes.object.isRequired,
};

shouldShowDownloadsButton.propTypes = {
  plot: PropTypes.object.isRequired,
};

shouldShowDetailButton.propTypes = {
  plot: PropTypes.object.isRequired,
};

notifyParentRegistrationClick.propTypes = {
  registrationUrl: PropTypes.string.isRequired,
  plotUuid: PropTypes.string.isRequired,
};
shouldDisplayPrice.propTypes = {
  plot: PropTypes.object.isRequired,
  displaySettings: PropTypes.object.isRequired,
};

shouldDisplayParking.propTypes = {
  plot: PropTypes.object.isRequired,
  displaySettings: PropTypes.object.isRequired,
};

export {
  buildRegistrationButtonUrl,
  isInIframe,
  notifyParentRegistrationClick,
  shouldDisplayParking,
  shouldDisplayPrice,
  shouldShowRegistrationButton,
  shouldShowFavoriteButton,
  shouldShowDownloadsButton,
  shouldShowDetailButton,
};
